// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"ef70b201","475":"2429194f","963":"d06d2468"}[chunkId] + ".chunk.js";
};